import { useFormaliteService } from '@europrocurement/l2d-domain';
import {
    DossierOpenSearchApiApiOpensearchPrescripteursGetCollectionRequest,
    DossierOpenSearchJsonldOpensearchDossierPrescripteurRead,
} from '@europrocurement/l2d-domain/openApi/ApiFormalite';

export type DossierPrescripteurs = DossierOpenSearchJsonldOpensearchDossierPrescripteurRead &
    Record<string, unknown>;

const useDossierPrescriber = () => {
    const { dossierOpenSearchApi } = useFormaliteService();
    let searchValideurTimeout: number | undefined;

    const searchDossierPrescriber = (term: string): Promise<Array<DossierPrescripteurs>> =>
        new Promise((resolve, reject) => {
            clearTimeout(searchValideurTimeout);
            const requestParameters: DossierOpenSearchApiApiOpensearchPrescripteursGetCollectionRequest =
                { q: term };

            searchValideurTimeout = setTimeout(() => {
                dossierOpenSearchApi
                    .apiOpensearchPrescripteursGetCollection(requestParameters)
                    .then((res) => resolve(res.data['hydra:member'] as Array<DossierPrescripteurs>))
                    .catch(() => reject());
            }, 300);
        });

    return { searchDossierPrescriber };
};

export default useDossierPrescriber;
